import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchData, updateData } from '../../apiService';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import Button from '@mui/material/Button';
import { Card, CardContent, Modal } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

function Home() {
    const { isAuthenticated, companyId, branchId, UserId, logout, token } = useAuth();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, UserId, token, logout, id]);

    useEffect(() => {
        fetchtableOCUUPIEDData();
    }, []);

    const [occupiedrooms, setOccupiedrooms] = useState([]);
    const fetchtableOCUUPIEDData = async () => {
        try {
            const response = await fetchData('RoomApi', `/FilledRooms/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                setOccupiedrooms(response.response_data);
            }
            console.log(response.response_data);
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    useEffect(() => {
        fetchtableFREEData();
    }, []);

    const [freerooms, setfreerooms] = useState([]);
    const fetchtableFREEData = async () => {
        try {
            const response = await fetchData('RoomApi', `/FreeRooms/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                setfreerooms(response.response_data);
            }
            console.log(response.response_data);
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };


    useEffect(() => {
        fetchtableRoomsunderMainatanance();
    }, []);

    const [roomsUnderMaintenance, setRoomsunderMainatanance] = useState([]);
    const fetchtableRoomsunderMainatanance = async () => {
        try {
            const response = await fetchData('RoomApi', `/RoomsUnderMaintanance/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                setRoomsunderMainatanance(response.response_data);
            }
            console.log(response.response_data);
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };



    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");




    const [roomsMaintenance, setRoomsMainatanance] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    
    const handleVacateClick = async (itemId) => {
        setConfirmationOpen(true);
        setSelectedItemId(itemId);
        setLoading(true);
    
        try {
            const response = await fetchData('RoomRegistrationApi', `/RoomRegisterDetails/${itemId}`, token);
    
            if (response.responseCode === '1111') {
                setRoomsMainatanance(response.response_data);
                console.log(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        } finally {
            setLoading(false); // Ensure loading is set to false after the request
        }
    };
    
    const handleConfirmVacate = () => {
        setConfirmationOpen(false);
        VacatingSubmit(selectedItemId);
    };

    const handleCancel = () => {
        setConfirmationOpen(false);
    };

    const VacatingSubmit = async (itemId) => {
        setIsLoading(true);

        const updatedFormData = {
            Id: roomsMaintenance.Id,
            CompanyId: companyId,
            BranchId: branchId,
            RoomId: roomsMaintenance.RoomId,
            SlabId: roomsMaintenance.SlabId,
            FirstName: roomsMaintenance.FirstName,
            LastName: roomsMaintenance.LastName,
            Email: roomsMaintenance.Email,
            ContactNumber: roomsMaintenance.ContactNumber,
            AddressLine1: roomsMaintenance.AddressLine1,
            AddressLine2: roomsMaintenance.AddressLine2,
            AddressProofId: roomsMaintenance.AddressProofId,
            AddressproofNo: roomsMaintenance.AddressproofNo,
            Purpose: roomsMaintenance.Purpose,
            RentAmount: roomsMaintenance.RentAmount,
            Discount: roomsMaintenance.Discount,
            FinalAmount: roomsMaintenance.FinalAmount,
            Remarks: roomsMaintenance.Remarks,
            CheckIn: roomsMaintenance.CheckIn,
            CheckOut: roomsMaintenance.CheckOut,
            TotalStay: roomsMaintenance.TotalStay,
            CheckInTime: roomsMaintenance.CheckInTime,
            CheckOutTime: roomsMaintenance.CheckOutTime,
            Isvacated : roomsMaintenance.Isvacated,
            CreatedDate: roomsMaintenance.CreatedDate,
            TaxableAmount: roomsMaintenance.TaxableAmount,
            GSTRate: roomsMaintenance.GSTRate,
            CGSTAmount: roomsMaintenance.CGSTAmount,
            SGSTAmount: roomsMaintenance.SGSTAmount,
            CreatedBy: roomsMaintenance.CreatedBy,
            UpdatedBy: UserId,
        };

        try {
            await updateData('RoomRentPaymentApi', `${itemId}`, updatedFormData, token);
            setSuccessMessages("Updated successfully!");
            setErrorMessages("");
            setTimeout(() => {
                setSuccessMessages("");
                setIsLoading(false);
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Error updating record:', error);
            setIsLoading(false);
        }
    };




    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto' }}>
            <style>
                {`
                    .container::-webkit-scrollbar {
                        width: 0.1em;
                    }
                    .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                    }
                    .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                    }
                `}
            </style>
            <div className="flex flex-wrap justify-between"></div>
            <div className="flex flex-wrap justify-between">
                <Card className="w-full sm:w-2/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                    <CardContent>
                        <div>
                            <h6 style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'darkred', fontWeight: 'bolder' }}>OCCUPIED ROOMS</h6>
                        </div>
                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {occupiedrooms && occupiedrooms.map((item) => (
                                <Card key={item.Id} className="customCard" style={{
                                    marginBottom: '10px',
                                    background: 'linear-gradient(to right, #FFB0B0, #FFB0B0)',
                                    color: 'white',
                                    marginLeft: '30px',
                                    height: '60px',
                                    boxSizing: 'border-box',
                                    width: '100px',
                                    cursor: 'pointer'
                                }}>
                                    <Link to={`/RoomRegisterDetails/${item.RoomRegisterId}`}>
                                        <IconButton color="primary" style={{ float: 'right' }}>
                                            <ArrowCircleRightIcon style={{ color: 'white', marginTop: '5px' }} />
                                        </IconButton>
                                    </Link>
                                    <CardContent style={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'left',
                                        padding: '10px',
                                        boxSizing: 'border-box'
                                    }}>
                                        <div style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textAlign: 'left'
                                        }}>
                                            {item.Name}
                                        </div>
                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </CardContent>
                </Card>


                <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                    <CardContent>
                        <h6 style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#DE3163', fontWeight: 'bolder', fontSize: '13px' }}>ROOMS UNDER MAINTENANCE</h6>
                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {roomsUnderMaintenance && roomsUnderMaintenance.map((item) => (
                                <Card key={item.Id} className="customCard" style={{
                                    marginBottom: '10px',
                                    background: 'linear-gradient(to right, #F5EFE3, #F5EFE3)',
                                    color: 'black',
                                    marginLeft: '20px',
                                    height: '60px',
                                    boxSizing: 'border-box',
                                    width: '200px',
                                    cursor: 'pointer'
                                }}>
                                    <CardContent style={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'left',
                                        padding: '10px',
                                        boxSizing: 'border-box'
                                    }}>
                                        <div style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textAlign: 'left'
                                        }}>
                                            {item.RoomName}
                                            <IconButton color="primary" style={{ float: 'right' }} onClick={() => handleVacateClick(item.Id)}>
                                                <ArrowCircleRightIcon style={{ color: 'red' }} />
                                                {isLoading ? <CircularProgress size={24} color="inherit" /> : <b></b>}
                                            </IconButton>
                                        </div>
                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </CardContent>
                </Card>

                <Modal open={confirmationOpen} onClose={handleCancel}>
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        maxWidth: '400px',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                    }}>
                        <h5 style={{ fontFamily: 'Times New Roman', fontWeight: 'bolder', textAlign: 'center' }}>Confirm Cleaning</h5>
                        <p style={{ textAlign: 'center', marginBottom: '20px' }}>Are you sure you want to complete room maintenance?</p>
                        <div style={{ textAlign: 'center' }}>
                            <Button onClick={handleConfirmVacate} disabled={isLoading} style={{ backgroundColor: 'brown', color: 'white', marginRight: '10px' }}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>YES</b>}
                            </Button>
                            <Button onClick={handleCancel} variant="contained" color="primary" disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>NO</b>}
                            </Button>
                        </div>
                    </div>
                </Modal>


                <Card className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                    <CardContent>
                        <div>
                            <h6 style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'darkgreen', fontWeight: 'bolder' }}>AVAILABLE ROOMS</h6>
                        </div>
                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {freerooms && freerooms.map((item) => (
                                // onClick={() => handleRoomOpen(item.ID)}
                                <Card key={item.Id} className="customCard" style={{
                                    marginBottom: '10px',
                                    background: 'linear-gradient(to right, #C9E9D2, #C9E9D2)',
                                    color: 'black',
                                    marginLeft: '20px',
                                    height: '60px',
                                    boxSizing: 'border-box',
                                    width: '300px',
                                    cursor: 'pointer'
                                }} >
                                    <CardContent style={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'left',
                                        padding: '10px',
                                        boxSizing: 'border-box'
                                    }}>
                                        <div style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            textAlign: 'left'
                                        }}>
                                            {item.Name}
                                            <Link to={`/RoomRegisterCreate/${item.Id}`}>
                                                <IconButton color="primary" style={{ float: 'right' }}>
                                                    <ArrowCircleRightIcon style={{ color: 'blueviolet' }} />
                                                </IconButton>
                                            </Link>
                                        </div>
                                    </CardContent>
                                </Card>
                            ))}
                        </div>
                    </CardContent>
                </Card>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
            </div>
        </div>
    );
}

export default Home;
